/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_SearchInputs */

const cs_settings_teams_search = /** @type {(inputs: Settings_Teams_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat týmy`)
};

const en_settings_teams_search = /** @type {(inputs: Settings_Teams_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search teams`)
};

/**
* | output |
* | --- |
* | "Search teams" |
*
* @param {Settings_Teams_SearchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_search = /** @type {((inputs?: Settings_Teams_SearchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_SearchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_search(inputs)
	return cs_settings_teams_search(inputs)
});